import apiClient from './axios';



export const getCurrentUser = () => {
    return apiClient.get('/admin/me');
}


export const login = (payload) => {
    return apiClient.post('/admin/login', payload);
}



export const requestSetNewPasswordCode = (phone) => {
    return apiClient.post('/admin/request-otp', phone);
}

export const verifySetNewPasswordCode = (payload) => {
    return apiClient.post('/admin/verify-otp', payload);
}


export const logout = () => {
    return apiClient.post('/admin/logout');
}


export const getSubscriptions = (url) => {
    if (url) {
        return apiClient.get(url);

    }
    return apiClient.get('/admin/subscriptions');

};


export const getStats = () => {
    return apiClient.get('/admin/stats');
};


export const exportExcelFile = () => {
    return apiClient.get('/admin/subscriptions/export', { responseType: 'blob' });
}

export const requestOtpForPasswordRecovery = (phone) => {
    return apiClient.post('/auth/admin/password/request-otp', { phone });
};

export const verifyOtpForPasswordRecovery = (payload) => {
    return apiClient.post('/auth/admin/password/verify-otp', payload);
};


export const resetPassword = (payload) => {
    return apiClient.post('/auth/admin/password/reset', payload);
};



export const updateAccountData = (payload) => {
    return apiClient.post('admin/data/update', payload);
};


export const requestOtpForPhoneNumberUpdate = (phone) => {
    return apiClient.post('admin/phone/update/request-otp', phone);
}


export const verifyOtpForPhoneNumberUpdate = (payload) => {
    return apiClient.post('admin/phone/update/verify-otp', payload);
}



export const getAdminList = () => {
    return apiClient.get('/admin/list');
}


export const changeAdminActiveStatus = (payload) => {
    return apiClient.post('/admin/activate' , payload);
}


export const createAdmin = (payload) => {
    return apiClient.post('/admin/create' , payload);
}